import React, { useEffect, useState } from "react";
import {
  Box, Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, IconButton, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Delete, Edit } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ManageCategories from "../ManageCategories/ManageCategories";

const ManageGuides = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [guideName, setGuideName] = useState("");
  const [guideImage, setGuideImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formError, setFormError] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editingGuideId, setEditingGuideId] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [userType, setUserType] = useState("");
  const navigate = useNavigate();

  const fetchGuides = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/approvedGuides`);
      setGuides(res.data);
    } catch (err) {
      console.error("Error fetching guides:", err);
    } finally {
      setLoading(false);
    }
  };

  const getUsernamefromCookie = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true });
      if (res.data.username) {
        setUsername(res.data.username);
        setUserType(res.data.user);
        setIsLoggedIn(true);
      } else {
        navigate("/login");
      }
    } catch (err) {
      console.error("Login check error:", err);
      navigate("/login");
    }
  };

  useEffect(() => {
    fetchGuides();
    getUsernamefromCookie();
  }, []);

  const handleFileChange = (e) => {
    setGuideImage(e.target.files[0]);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setGuideName("");
    setGuideImage(null);
    setFormError("");
    setEditMode(false);
    setEditingGuideId(null);
  };

  const handleEditGuide = (guide) => {
    setGuideName(guide.name);
    setEditingGuideId(guide._id);
    setEditMode(true);
    setOpenDialog(true);
  };
const handleDeactivateGuide = async (guide) => {
  try {
    await axios.put(`${API_BASE_URL}/api/deactivateGuide/${guide._id}`);
    fetchGuides(); 
  } catch (error) {
    console.error("Error deactivating guide:", error);
  }
};

  const handleSaveGuide = async () => {
    if (!guideName) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("guide", guideName);
      if (guideImage) formData.append("image", guideImage);

      if (editMode) {
        formData.append("lastEditedBy", username);
        formData.append("id", editingGuideId);
        await axios.put(`${API_BASE_URL}/api/updateGuide`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
      } else {
        formData.append("createdBy", username);

        const existsRes = await axios.post(`${API_BASE_URL}/api/checkGuide`, { name: guideName });
        if (existsRes.data.exists) {
          setFormError(existsRes.data.message);
          return;
        }

        let imageUrl = "";
        if (guideImage) {
          const pdfUpload = await axios.post(`${API_BASE_URL}/api/upload-image-guide`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          imageUrl = pdfUpload.data.imageUrl;
        }

        await axios.post(`${API_BASE_URL}/api/createGuide`, {
          name: guideName,
          eventImage: imageUrl,
          createdBy: username
        });
      }

      handleDialogClose();
      fetchGuides();
    } catch (error) {
      setFormError(error?.response?.data?.message || "Error saving guide");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box p={3}>
      {/* <Typography variant="h4" gutterBottom>Manage Guides</Typography> */}
      {/* {userType === "Admin" && ( */}
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenDialog(true)} sx={{ mb: 2 }}>
          Add Guide
        </Button>
       {/* )} */}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>College Counseling Resources</strong></TableCell>
                <TableCell><strong>Pdf</strong></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {guides.map((g) => (
                <TableRow key={g._id}>
                  <TableCell>{g.name}</TableCell>
                  <TableCell>
                    {g.eventImage ? (
                        g.eventImage.endsWith('.pdf') ? (
                            <a href={g.eventImage} target="_blank" rel="noopener noreferrer">
                            {g.name}
                            </a>
                        ) : (
                            <img
                            src={g.eventImage}
                            alt={g.name}
                            width={80}
                            height={60}
                            style={{ objectFit: "cover", borderRadius: "4px" }}
                            />
                        )
                        ) : "No file"}
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleEditGuide(g)}><Edit /></IconButton>
                    <IconButton onClick={() => handleDeactivateGuide(g)}><Delete/></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={openDialog} onClose={handleDialogClose} fullWidth maxWidth="sm">
        <DialogTitle>{editMode ? "Edit Guide" : "Add New Guide"}</DialogTitle>
        <DialogContent dividers>
          {formError && <Typography color="error" sx={{ textAlign: "center" }}>{formError}</Typography>}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField fullWidth label="Guide Name" value={guideName} onChange={(e) => setGuideName(e.target.value)} />
            <input type="file" accept="application/pdf" onChange={handleFileChange} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveGuide} disabled={uploading}>
            {uploading ? "Saving..." : editMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ManageGuides;
